import axiosInstance from 'api/axios';

export interface podcastInputType {
  prompt: string;
  duration: number;
  generate_text: boolean;
  characters: {
    character_name: string;
    voice_name: string;
    role: 'host' | 'guest';
    gender: 'M' | 'F';
    qualities?: string[];
    age: number;
  }[];
}

export interface podcastApiResponse {
  success: boolean;
  message: string;
  data: {
    dialogues: {
      character_name: string;
      voice_name: string;
      dialogue: string;
      role: 'host' | 'guest';
      preview_url: string;
      presigned_preview_url : string
    }[];
  };
}

export interface regenApiReq {
  regenerate_part: string;
  voice_name: string;
  podcast_script: {
    character_name: string;
    voice_name: string;
    dialogue: string;
    role: 'host' | 'guest';
    preview_url: string;
  }[];
  user_prompt: string;
}

export interface regenApiRes {
  success: boolean;
  message: string;
  data: {
    regenerated_dialogue: string;
    preview_url: string;
    presigned_preview_url : string
  };
}

export interface generatePodcastInputType {
  title: string,
  prompt: string,
  duration: number,
  script: {
    character_name: string,
    voice_name: string,
    dialogue: string,
    role: string,
    preview_url: string
  }[],
}

export interface EditDialogueRequest {
  dialogue: string;
  voice_name: string;
}

export interface EditDialogueResponse {
  success: boolean;
  message: string;
  data: {
    preview_url: string;
    presigned_preview_url: string;
  };
}

export const podcastServices = {
  generateDialogues: async (
    podcastInput: podcastInputType
  ): Promise<podcastApiResponse> => {
    const response = await axiosInstance.private.post(
      `/api/v1/podcast/generate-dialogues`,
      podcastInput
    );

    return response.data;
  },
  regenerateDialogue: async (regenInput: regenApiReq): Promise<regenApiRes> => {
    const response = await axiosInstance.private.post(
      `/api/v1/podcast/regenerate-dialogue`,
      regenInput
    );

    return response.data;
  },
  generatePodcast: async (
    generatePodcastInput: generatePodcastInputType
  ) => {
    const response = await axiosInstance.private.post(
      '/api/v1/podcast/generate-podcast',
      generatePodcastInput
    );
    return response.data;
  },
  editDialogue: async (editRequest: EditDialogueRequest): Promise<EditDialogueResponse> => {
    const response = await axiosInstance.private.post(
      `/api/v1/podcast/edit-dialogue`,
      editRequest
    );

    return response.data;
  }
};
